var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRead = function SvgRead(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12,
    r: 10,
    fill: "#0CCD78"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.622 9.427l4.623-2.772a.5.5 0 01.514 0l4.62 2.773a.25.25 0 01.121.214V16a.5.5 0 01-.5.5H8a.5.5 0 01-.5-.5V9.642a.25.25 0 01.122-.215zm.878.64V15.5h8v-5.434l-3.998-2.4-4.002 2.4zm4.03 2.782l2.648-2.231.644.765-3.285 2.768-3.355-2.765.636-.772 2.712 2.235z"
  })));
};
export default SvgRead;